import React, { useContext, useState, useEffect } from 'react';
import Redirect from 'react-router-dom/Redirect';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Texfield from '@material-ui/core/TextField';
import Alert from '../../../components/Alert';
import Button from '../../../components/Button';
import { useLogin } from '../../../services/useLogin';
import { AuthContext } from '../../../providers/AuthProvider';
import { MessageContext } from '../../../providers/MessageProvider';
import validate from './validation';
import background from '../../../assets/images/login_background.jpg';
import logo from '../../../assets/images/beneficios.svg';

//  Comentario de prueba para publicación en producción

const dummy = [
  {
    type: 'text',
    name: 'username',
    label: 'Email',
    required: true,
  },
  {
    type: 'password',
    name: 'password',
    label: 'Contraseña',
    required: true,
  },
];

const formValues = {};

dummy.forEach((input) => {
  formValues[input.name] = '';
});

const useStyles = makeStyles(theme => ({
  root: {
    background: `${theme.palette.primary.main} url(${background}) center/cover no-repeat`,
    height: '100vh',
    width: '100vw',
  },
  wrapper: {
    background: `${theme.palette.primary.contrastText}`,
  },
  form: {
    maxWidth: '100%',
    padding: theme.spacing(3),
    textAlign: 'center',
    width: 320,
  },
  imageWrapper: {
    lineHeight: 0,
  },
  logo: {
    height: 56,
    width: 200,
  },
  inputWrapper: {
    marginBottom: theme.spacing(1),
  },
  errorWrapper: {
    marginBottom: theme.spacing(1),
  },
  error: {
    marginBottom: theme.spacing(1),
  },
}));

function Login() {
  const { isLoggedIn } = useContext(AuthContext);
  const messages = useContext(MessageContext);
  const classes = useStyles();
  const [form, setFormValues] = useState(formValues);
  const [errorsType, setErrorsType] = useState({});
  const [setForm, doLogin, isLoading] = useLogin();

  useEffect(() => {
    setForm(form);
    // console.log('error');user/
  }, [form]);

  if (isLoggedIn) {
    return <Redirect to={{ pathname: '/colaborador/colaborador' }} />;
  }

  function handleInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    setFormValues({ ...form, [name]: value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setErrorsType({});
    const result = await validate(form);
    setErrorsType(result.errors);
    if (!result.isValid) {
      return;
    }
    doLogin(form);
  }

  function renderInputs() {
    return dummy.map(input => (
      <Grid key={input.name} item xs={12}>
        <Texfield
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          type={input.type}
          name={input.name}
          label={input.label}
          value={form[input.name]}
          onChange={handleInputChange}
          // required={input.required}
          fullWidth
          error={!!errorsType[`${input.name}`]}
        // helperText={errorsType[`${input.name}`]}
        />
      </Grid>
    ));
  }

  function renderErrors() {
    const element = messages.map((error, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Alert key={index} className={classes.error} type={error.type}>
        {error.message}
      </Alert>
    ));
    return element;
  }

  const fields = renderInputs();
  const errors = renderErrors();

  return (
    <Grid container item xs={12} classes={{ root: classes.root }}>
      <Grid
        container
        item
        xs={12}
        md={5}
        xl={4}
        alignItems="center"
        justify="center"
        classes={{ root: classes.wrapper }}
        component={Paper}
        elevation={6}
        square
      >
        <form className={classes.form} action="/sign_in" method="post" onSubmit={handleSubmit}>
          <Grid item xs={12} className={classes.imageWrapper}>
            <img
              className={classes.logo}
              src={logo}
              alt="Grupo Romero"
            />
          </Grid>
          <Grid item xs={12} className={classes.inputWrapper}>
            {fields}
          </Grid>
          <Collapse in={errors.length > 0}>
            <Grid item xs={12} className={classes.errorWrapper}>
              {errors}
            </Grid>
          </Collapse>
          <Button color="primary" type="submit" disabled={isLoading}>Ingresar</Button>
        </form>
      </Grid>
    </Grid>
  );
}

export default Login;
